import baseGetGAData from 'utils/getGAData';

export default function getGAData(a, data, gaCategory) {
	let tData = baseGetGAData(...arguments);
	if (data.a === 'home-ent-links') {
		tData.eventCategory = 'Retailer Button';
		tData.eventAction = 'Buy Now Page';
	}
	if (data.a === 'limited-offers-links') {
		tData.eventCategory = 'Retailer Button';
		tData.eventAction = 'Exclusives Page';
	}
	return tData;
}
